@if (offerNumber) {
  <div
    class="legal"
    [innerHTML]="
      'booking.overview.offer.text'
        | transloco
          : {
              linkText:
                '<a class=offer-link-button-trigger>' +
                ('booking.overview.offer.linkText' | transloco) +
                '</a>',
              offerNumber,
            }
    "
  ></div>
}
